<template>
	<div class="drip-campaign-settings">
		<FallBack
			class="impersonation-warning-message"
			v-if="isImpersonated"
			iconStyle="fal"
			icon="exclamation-triangle"
			message="Drip Campaigns cannot be managed for others while impersonating."
		/>
		<div
			class="setting-item"
			v-if="displaySettings"
			:class="{ 'setting-item--disabled': isImpersonated }"
		>
			<ToggleSwitch
				:value="currentDripCampaignActive"
				:disabled="
					isImpersonated ||
					!companyHasBlinkRegistration ||
					!userHasBlinkRegistration
				"
				@click="saveActiveInd"
			/>
			<div class="setting-label">Campaign Opt-in/out</div>
		</div>
		<p v-if="!error" class="drip-sync-message">
			Please remember to set the "Enable CRM Syncing" option to ON in Blink+ in
			order to send your borrower leads to Brand 360! You can find this at the
			bottom of your Blink+ My Account screen.
		</p>
		<FallBack
			v-if="error"
			iconStyle="fal"
			icon="exclamation-triangle"
			:message="error"
		/>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import AlertMessage from '@/components/global/AlertMessage.vue';
import FallBack from '@/components/global/FallBack.vue';
import ToggleSwitch from '@/components/global/ToggleSwitch.vue';

export default {
	name: 'DripCampaignsSettings',
	components: {
		AlertMessage,
		FallBack,
		ToggleSwitch,
	},
	props: {
		dripCampaignId: null,
	},
	data() {
		return {
			activeInd: null,
			error: null,
		};
	},
	computed: {
		...mapState({
			contactId: (state) =>
				state.profileSwitcher.profileSelector.rolodexContactId,
			entityId: (state) =>
				state.profileSwitcher.profileSelector.brokerShopDetails[0].shopDetail
					.rolodexEntityId,
			modifiedByUserId: (state) => state.profile.contactId,
			companyHasBlinkRegistration: (state) =>
				state.companyProfile.blinkRegistrationInd,
			userHasBlinkRegistration: (state) => state.profile.blinkRegistrationInd,
		}),
		...mapGetters(['isImpersonated', 'currentDripCampaignActive']),
		displaySettings() {
			return !this.error && this.currentDripCampaignActive !== 'null';
		},
	},
	methods: {
		...mapActions(['saveCampaignSetting']),
		async saveActiveInd(activeInd) {
			this.error = null;
			const settingsInfo = {
				activeInd,
				dripCampaignId: this.dripCampaignId,
				entityId: this.entityId,
				contactId: this.contactId,
				modifiedByUserId: this.modifiedByUserId,
			};
			try {
				await this.saveCampaignSetting(settingsInfo);
			} catch (error) {
				this.error =
					'We were unable to save the changes. Please try again in a few moments.';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.drip-campaign-settings {
	@include rem('padding', 30px 0);

	.setting-item {
		display: flex;

		.setting-label {
			@include rem('padding-left', 15px);
		}

		&.setting-item--disabled {
			opacity: 0.7;
			cursor: not-allowed;
		}
	}

	.impersonation-warning-message {
		flex-direction: row;
		justify-content: start;
		align-items: flex-start;
		height: auto;
		width: calc(100% - 15px);
		@include rem('margin', 0 0 30px 0);
		@include rem('padding', 10px);

		/deep/ .icon {
			font-size: 22px;
		}

		/deep/ .message {
			@include rem('margin', 0 0 0 10px);
		}

		@include larger-than-mobile {
			width: max-content;
			max-width: calc(100% - 30px);
			align-items: center;
		}
	}

	.drip-sync-message {
		@include rem('padding-top', 32px);
	}
}
</style>
